import { render, staticRenderFns } from "./UserAddNew.vue?vue&type=template&id=f527f4b8&scoped=true&"
import script from "./UserAddNew.vue?vue&type=script&lang=js&"
export * from "./UserAddNew.vue?vue&type=script&lang=js&"
import style0 from "./UserAddNew.vue?vue&type=style&index=0&id=f527f4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f527f4b8",
  null
  
)

export default component.exports